"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonBackgroundColorVar = exports.getButtonBackgroundColor = exports.buttonBackgroundColors = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _mapButtonAppearance = require("./mapButtonAppearance");
// In app-core (oldestar theme), Buttons have an opacity of 0.3 applied to them when they are
// disabled. We've used gpick to approximate this for the oldestar theme w/o an opacity filter.
const buttonBackgroundColors = (0, _sdsThemeInternal.themed)({
  primary: {
    //only used in lodestar-light
    rest: _designTokens.lodestarColors.buttonPrimary,
    //#3576ba no token exists
    focus: _designTokens.lodestarColors.buttonPrimaryFocus,
    //#3576ba no token exists
    hover: _designTokens.lodestarColors.buttonPrimaryHover,
    //#6097d2 no token exists
    active: _designTokens.lodestarColors.buttonPrimaryPressed,
    //#4c649d no token exists
    disabled: _designTokens.lodestarColors.buttonPrimaryDisabled //#b3ccea no token exists
  },

  secondary: {
    //only used in lodestar-light
    rest: _designTokens.lodestarColors.buttonDefault,
    //#eeeeee no token exists
    focus: _designTokens.lodestarColors.buttonDefaultFocus,
    //#eeeeee no token exists
    hover: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.buttonDefaultHover),
    active: (0, _designTokensReact.color)("color--background--neutral--strong", _designTokens.lodestarColors.buttonDefaultPressed),
    disabled: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.lodestarColors.buttonDefaultDisabled)
  },
  destructive: {
    //only used in lodestar-light
    rest: _designTokens.lodestarColors.buttonDestructive,
    //#cc2e3b no token exists
    focus: _designTokens.lodestarColors.buttonDestructiveFocus,
    //#cc2e3b no token exists
    hover: (0, _designTokensReact.color)("color--background--destructive--weak", _designTokens.lodestarColors.dangerLight10),
    active: (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.lodestarColors.buttonDestructivePressed),
    disabled: _designTokens.lodestarColors.buttonDestructiveDisabled //#edbec2 no token exists
  },

  "secondary-destructive": {
    //only used in lodestar-light
    rest: _designTokens.lodestarColors.buttonDefault,
    //#eeeeee no token exists
    focus: _designTokens.lodestarColors.buttonDefaultFocus,
    //#eeeeee no token exists
    hover: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.buttonDefaultHover),
    active: (0, _designTokensReact.color)("color--background--neutral--strong", _designTokens.lodestarColors.buttonDefaultPressed),
    disabled: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.lodestarColors.buttonDefaultDisabled)
  },
  share: {
    //only used in lodestar-light
    rest: _designTokens.lodestarColors.ctaShare,
    //#007e84 no token exists
    focus: _designTokens.lodestarColors.ctaShareFocus,
    //#007e84 no token exists
    hover: _designTokens.lodestarColors.ctaShareHover,
    //#40bac0 no token exists
    active: _designTokens.lodestarColors.ctaShareActive,
    //#01595d no token exists
    disabled: _designTokens.lodestarColors.ctaShareDisabled //#aed5d6 no token exists
  },

  borderless: {
    //only used in lodestar-light
    rest: "transparent",
    hover: _designTokens.lodestarColors.buttonDefault,
    //#eeeeee no token exists
    active: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.buttonDefaultHover),
    focus: _designTokens.lodestarColors.buttonDefault,
    //#eeeeee no token exists
    disabled: "transparent"
  },
  link: {
    rest: "transparent",
    hover: "transparent",
    active: "transparent",
    focus: "transparent",
    disabled: "transparent"
  },
  //Below are exclusive to ursa-light
  "primary-filled": {
    rest: (0, _designTokensReact.color)("color--background--primary--default", _designTokens.ursaColors.blue500),
    hover: (0, _designTokensReact.color)("color--background--primary--strong", _designTokens.ursaColors.blue600),
    active: (0, _designTokensReact.color)("color--background--primary--stronger", _designTokens.ursaColors.blue700),
    focus: (0, _designTokensReact.color)("color--background--primary--default", _designTokens.ursaColors.blue500),
    disabled: (0, _designTokensReact.color)("color--background--primary--weak", _designTokens.ursaColors.blue300)
  },
  "primary-empty": {
    rest: "transparent",
    hover: (0, _designTokensReact.color)("color--background--primary--weakest", _designTokens.ursaColors.blue50),
    active: (0, _designTokensReact.color)("color--background--primary--weaker", _designTokens.ursaColors.blue75),
    focus: (0, _designTokensReact.color)("color--background--neutral--weakest", _designTokens.ursaColors.neutral00),
    disabled: "transparent"
  },
  "secondary-filled": {
    rest: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50),
    hover: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.ursaColors.neutral75),
    active: (0, _designTokensReact.color)("color--background--neutral--strong", _designTokens.ursaColors.neutral100),
    focus: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50),
    disabled: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50)
  },
  "secondary-outlined": {
    rest: (0, _designTokensReact.color)("color--background--surfaces--body", _designTokens.ursaColors.neutral00),
    hover: (0, _designTokensReact.color)("color--background--neutral--weak", _designTokens.ursaColors.neutral60),
    active: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.ursaColors.neutral75),
    focus: (0, _designTokensReact.color)("color--background--surfaces--body", _designTokens.ursaColors.neutral00),
    disabled: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50)
  },
  "secondary-empty": {
    rest: "transparent",
    hover: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50),
    active: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.ursaColors.neutral75),
    focus: (0, _designTokensReact.color)("color--background--neutral--weakest", _designTokens.ursaColors.neutral00),
    disabled: "transparent"
  },
  "canvas-filled": {
    rest: (0, _designTokensReact.color)("color--background--neutral--weakest", _designTokens.ursaColors.neutral35),
    hover: (0, _designTokensReact.color)("color--background--slate--weak", _designTokens.ursaColors.slate60),
    active: (0, _designTokensReact.color)("color--background--slate--default", _designTokens.ursaColors.slate75),
    focus: (0, _designTokensReact.color)("color--background--slate--weaker", _designTokens.ursaColors.slate50),
    disabled: (0, _designTokensReact.color)("color--background--neutral--weakest", _designTokens.ursaColors.neutral35)
  },
  "canvas-empty": {
    rest: (0, _designTokensReact.color)("color--background--surfaces--canvas", _designTokens.ursaColors.neutral25),
    hover: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.ursaColors.neutral50),
    active: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.ursaColors.neutral75),
    focus: "transparent",
    disabled: (0, _designTokensReact.color)("color--background--neutral--weakest", _designTokens.ursaColors.neutral35)
  },
  "destructive-filled": {
    rest: (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.ursaColors.red500),
    hover: (0, _designTokensReact.color)("color--background--destructive--stronger", _designTokens.ursaColors.red600),
    active: (0, _designTokensReact.color)("color--background--destructive--strongest", _designTokens.ursaColors.red700),
    focus: (0, _designTokensReact.color)("color--background--destructive--strong", _designTokens.ursaColors.red500),
    disabled: (0, _designTokensReact.color)("color--background--destructive--weak", _designTokens.ursaColors.red300)
  },
  "destructive-empty": {
    rest: "transparent",
    hover: (0, _designTokensReact.color)("color--background--destructive--weakest", _designTokens.ursaColors.red50),
    active: (0, _designTokensReact.color)("color--background--destructive--weaker", _designTokens.ursaColors.red75),
    focus: "transparent",
    disabled: "transparent"
  }
});
exports.buttonBackgroundColors = buttonBackgroundColors;
const canvasEmptyAndLodestarStates = {
  //appearance canvas-empty within the lodestar-light theme should map to secondary backgrounds with transparent rest
  rest: "transparent",
  focus: _designTokens.lodestarColors.buttonDefaultFocus,
  //#eeeeee no token exists
  hover: (0, _designTokensReact.color)("color--background--neutral--default", _designTokens.lodestarColors.buttonDefaultHover),
  active: (0, _designTokensReact.color)("color--background--neutral--strong", _designTokens.lodestarColors.buttonDefaultPressed),
  disabled: (0, _designTokensReact.color)("color--background--neutral--weaker", _designTokens.lodestarColors.buttonDefaultDisabled)
};

// For mapping state to the color object above
const mapStateToBackgroundString = _ref => {
  let {
    state,
    focusMode
  } = _ref;
  // Disabled should always win
  if (state.isDisabled) {
    return "disabled";
  }
  // Active should win over hover
  if (state.isActive) {
    return "active";
  }
  if (state.isFocus && focusMode === "keyboard") {
    return "focus";
  }
  if (state.isHover) {
    return "hover";
  }
  return "rest";
};
const getButtonBackgroundColor = props => {
  const resolvedState = mapStateToBackgroundString(props);
  const {
    themeMode,
    isCanvasEmptyAndLodestar
  } = props;
  if (themeMode === "lodestar-light" && isCanvasEmptyAndLodestar) {
    return canvasEmptyAndLodestarStates[resolvedState];
  }
  return buttonBackgroundColors[(0, _mapButtonAppearance.mapButtonAppearance)(props.appearance, props.themeMode)][resolvedState](props.themeMode);
};

// For mapping state to the color object above
exports.getButtonBackgroundColor = getButtonBackgroundColor;
const mapStateToBackgroundVar = _ref2 => {
  let {
    state,
    focusMode
  } = _ref2;
  // Disabled should always win
  if (state.isDisabled) {
    return "--smar--sds--button--color--background--disabled";
  }
  // Active should win over hover
  if (state.isActive) {
    return "--smar--sds--button--color--background--active";
  }
  if (state.isFocus && focusMode === "keyboard") {
    return "--smar--sds--button--color--background--focus";
  }
  if (state.isHover) {
    return "--smar--sds--button--color--background--hover";
  }
  return "--smar--sds--button--color--background--rest";
};
const getButtonBackgroundColorVar = props => {
  return `${mapStateToBackgroundVar(props)}`;
};
exports.getButtonBackgroundColorVar = getButtonBackgroundColorVar;
//# sourceMappingURL=getButtonBackgroundColor.js.map